"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLanguageDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
function ChangeLanguageDialog({ isOpen, onConfirm: onConfirmProp, onCancel, language, styles, dialogText, }) {
    const [selectedLanguage, setSelectedLanguage] = (0, react_1.useState)(language);
    const [isConfirmed, setIsConfirmed] = (0, react_1.useState)(false);
    const onConfirm = () => {
        onConfirmProp();
        setIsConfirmed(true);
    };
    (0, react_1.useEffect)(() => {
        if (!isOpen) {
            return;
        }
        setSelectedLanguage(language);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    const title = (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.title, {
        language: selectedLanguage,
    });
    const text = (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.text);
    let buttons = [
        (0, jsx_runtime_1.jsx)(StyledFlatButton, { onClick: onCancel, size: ui_1.ButtonSize.Small, "data-e2e": 'ChangeLanguageDialog_StyledFlatButton', children: (dialogText === null || dialogText === void 0 ? void 0 : dialogText.cancelBtnText) ||
                (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.cancel) }, "cancel"),
        (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { onClick: onConfirm, size: ui_1.ButtonSize.Small, "data-e2e": 'ChangeLanguageDialog_StyledPrimaryButton', children: (dialogText === null || dialogText === void 0 ? void 0 : dialogText.confirmBtnText) ||
                (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.confirm, { language: selectedLanguage }) }, "confirm"),
    ];
    if (isConfirmed) {
        const restartMessage = ((0, jsx_runtime_1.jsx)(RestartMessage, { "data-e2e": 'ChangeLanguageDialog_RestartMessage', children: (0, i18n_1.Localized)(i18n_1.Strings.popups.trialEnd.subheading) }));
        buttons = [
            (0, jsx_runtime_1.jsx)(StyledFakeProgressBar, { message: restartMessage, "data-e2e": 'ChangeLanguageDialog_StyledFakeProgressBar' }, "progress"),
        ];
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.Dialog, { isOpen: isOpen, title: (dialogText === null || dialogText === void 0 ? void 0 : dialogText.title) || title, buttons: buttons, centered: true, backgroundStyle: {
            style: Object.assign({}, styles),
        }, "data-e2e": 'ChangeLanguageDialog_Dialog', children: (0, jsx_runtime_1.jsx)(Text, { "data-e2e": 'ChangeLanguageDialog_Text', children: text }) }));
}
exports.ChangeLanguageDialog = ChangeLanguageDialog;
const Text = styled_components_1.default.div `
  margin-bottom: 40px;
  margin-top: 20px;

  font-size: 16px;
  text-align: center;
`;
const StyledPrimaryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  text-transform: uppercase;
  width: 50%;

  border-radius: 4px;

  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;

  background-color: ${({ theme }) => theme.grasshopper.focusBorder};

  ${ui_1.deviceMainScreen.mobile `
    width: 100%;
  `}
`;
const StyledFlatButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  text-transform: uppercase;
  width: 50%;

  border: 1px solid ${({ theme }) => theme.grasshopper.focusBorder};
  border-radius: 4px;

  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;

  color: ${({ theme }) => theme.grasshopper.focusBorder};

  ${ui_1.deviceMainScreen.mobile `
    width: 100%;
  `}
`;
const StyledFakeProgressBar = (0, styled_components_1.default)(ui_1.FakeProgressBar) `
  width: 250px;
  height: 10px;

  background: #ffffff;
  border-radius: 10px;
`;
const RestartMessage = styled_components_1.default.div `
  font-weight: 700;
  font-size: 15px;
  text-align: center;
`;
